import axios, { AxiosError } from "axios";

const API_URL = process.env.REACT_APP_API_URL;

type Filter = { userIds?: number[] } | undefined;

type ApiResult<T = any> = {
  success: boolean;
  data?: T;
  message?: string;
  error?: any;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleAxiosError = (err: AxiosError | any) => {
  const message =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    "Erreur serveur";
  return { success: false, message, error: err?.response?.data || err };
};

const discountLimitsService = {
  async updateAllLimits({
    percentage,
    active,
    filter,
  }: {
    percentage: number;
    active: boolean;
    filter?: Filter;
  }): Promise<ApiResult> {
    try {
      const res = await axios.post(
        `${API_URL}/promo-code/update-all`,
        { percentage, active, filter },
        { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
      );
      return { success: true, data: res.data };
    } catch (err) {
      return handleAxiosError(err);
    }
  },

  async toggleAllLimits({
    active,
    filter,
  }: {
    active: boolean;
    filter?: Filter;
  }): Promise<ApiResult> {
    try {
      const res = await axios.post(
        `${API_URL}/promo-code/toggle-all`,
        { active, filter },
        { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
      );
      return { success: true, data: res.data };
    } catch (err) {
      return handleAxiosError(err);
    }
  },

  async resetAllLimits({ filter }: { filter?: Filter } = {}): Promise<ApiResult> {
    try {
      const res = await axios.post(
        `${API_URL}/user/discount-limits/reset-all`,
        { filter },
        { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
      );
      return { success: true, data: res.data };
    } catch (err) {
      return handleAxiosError(err);
    }
  },

  // Petit helper pour update individuel (si tu veux centraliser)
  async updateUserLimit({
    userId,
    percentage,
    active,
  }: {
    userId: number;
    percentage: number;
    active: boolean;
  }): Promise<ApiResult> {
    try {
      const res = await axios.put(
        `${API_URL}/user/discount-limit/${userId}`,
        { percentage, active },
        { headers: { "Content-Type": "application/json", ...getAuthHeaders() } }
      );
      return { success: true, data: res.data };
    } catch (err) {
      return handleAxiosError(err);
    }
  },
};

export default discountLimitsService;
